import { createContext } from "react";


export const SmartWatchContext = createContext()